<template>
  <div class="wrap-box">
    <el-card class="wrap-card" shadow="never" :body-style="{height: '100%',padding:Padding}">
      <slot/>
    </el-card>
  </div>
</template>
<script>
export default {
  name: 'WrapBox',
  props: {
    Padding: {
      type: String,
      default: '15px'
    }
  }
}
</script>
<style scoped lang="scss">
.wrap-card {
  height: 100%;
}
</style>
